import { inject, Injectable } from '@angular/core';

import { SubscriptionListBloc } from '@connect-services/client/blocs/subscription-list.bloc';
import { Subscription } from '@connect-services/client/sdk/api';
import { SecurityService } from '@connect-services/client/services/security.service';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    private readonly securityService = inject(SecurityService);
    private readonly subscriptionListBloc = inject(SubscriptionListBloc);

    public async getSubscription(): Promise<Subscription> {
        await this.subscriptionListBloc.load({ organization: this.securityService.meSignal()?.organization.id });

        if (!this.subscriptionListBloc.value()?.items.length) {
            throw new Error("No subscription found for the current user's organization.");
        }

        // take the first and only subscription for now
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionListBloc.value()!.items[0];
    }
}
